import React, {
  forwardRef,
  useMemo,
  useContext
} from "react";
import { cx } from "@linaria/core";
import { SelectContext } from "../state";
import { OptionWrapper, CheckboxOn, CheckboxOff } from "./Select.styles";
const checkAllSelected = (options, selected) => options.length > 0 && options.length === selected.length && options.every((option) => selected.includes(option));
const SelectAllOption = ({
  disabled = false,
  label,
  innerRef
}) => {
  const { onChange, menuId, selectedValues, options } = useContext(SelectContext);
  const { current } = options;
  return useMemo(() => {
    const allOptions = current?.options ?? [];
    const disabledOptions = current?.disabledOptions ?? [];
    const initialOptions = disabledOptions.filter((option) => selectedValues.includes(option));
    const allEnabledOptions = allOptions.filter((option) => {
      return disabledOptions.includes(option) ? selectedValues.includes(option) : true;
    });
    const allSelected = checkAllSelected(allEnabledOptions, selectedValues);
    const classNames = cx("is-multiselect", disabled && "is-disabled", "select-all-option", allSelected && "is-selected");
    const handleSelectAllClick = (event) => {
      if (disabled)
        return;
      const newValues = allSelected ? initialOptions : allEnabledOptions;
      const newEvent = { ...event };
      newEvent.target.value = newValues;
      onChange(newEvent);
    };
    return /* @__PURE__ */ React.createElement(OptionWrapper, {
      role: "option",
      onClick: handleSelectAllClick,
      className: classNames,
      "aria-selected": allSelected,
      id: `${menuId}_allSelect`,
      ref: innerRef
    }, label, allSelected ? /* @__PURE__ */ React.createElement(CheckboxOn, null) : /* @__PURE__ */ React.createElement(CheckboxOff, null));
  }, [innerRef, current, disabled, label, menuId, onChange, selectedValues]);
};
export default forwardRef((props, ref) => /* @__PURE__ */ React.createElement(SelectAllOption, {
  ...props,
  innerRef: ref
}));
